export default function sanityLoader({ src, width, quality } : { src: string, width: number, quality: number }) {
  // Local static files in /public — pass through unchanged.
  if (src.startsWith('/')) {
    return src;
  }

  const url = src.startsWith('http')
    ? new URL(src)
    : new URL(`https://cdn.sanity.io/${src}`);

  if (url.hostname === 'substack-post-media.s3.amazonaws.com') {
    return `https://substackcdn.com/image/fetch/w_${width},c_limit,f_auto,q_auto:good/${encodeURIComponent(url.href)}`;
  }

  if (!url.searchParams.has('auto')) url.searchParams.set('auto', 'format');
  if (!url.searchParams.has('fit')) url.searchParams.set('fit', 'max');
  url.searchParams.set('w', width.toString());

  if (quality && !url.searchParams.has('q')) {
    url.searchParams.set('q', quality.toString());
  }

  return url.href;
};
